module.exports = __webpack_public_path__ + "img/motorcheck-pattern.0c2acb97.png";